import React from 'react';
import { Skeleton } from 'antd';

interface LoadingProps {
	active?: boolean;
	children: JSX.Element;
}

export const Loading = ({ active = true, children }: Readonly<LoadingProps>) => {
	return active ? <Skeleton.Input active /> : children;
};
